import { regionI, regionListI } from 'interfaces';
import { get, patch, post, remove } from "services/services.methods";
import { RegionsPaths } from 'services/services.paths';

export const getRegion = async () => {
  const response = await get<regionListI[]>(RegionsPaths.get);

  return response.data;
};

export const removeRegion = async (id: number) => {
  const response = await remove<any>(RegionsPaths.delete + `/${id}`);

  return response;
};

export const createRegion = async (Region: regionI) => {
  const response = await post<any>(RegionsPaths.post, Region);

  return response;
};

export const updateRegion = async ( RegionId: number, Region: regionI ) => {
  const response = await patch<any>(RegionsPaths.put + `/${RegionId}`, Region);

  return response;
};